export const language = {
  en: {
    'Buyer Center': 'Buyer Center',
    'Supplier Center': 'Supplier Center',
    'Hello': 'Hello',
    'RFQs': 'RFQs',
    'Orders': 'Orders',
    'Purchase Amount': 'Purchase Amount',
    'Resource Hub': 'Resource Hub',
    'Entering Resource Hub': 'Entering Resource Hub',
    'No Data': "No Data"
  },
  zh: {
    "Buyer Center": "买家中心",
    "Supplier Center": "供应商中心",
    'Hello': "你好",
    RFQs: "已发起RFQ",
    Orders: "订单数",
    "Purchase Amount": "采购额",
    "Resource Hub": "采购学堂",
    "Entering Resource Hub": "进入采购学堂",
    'No Data': "暂无数据"
  },
};

